<script>
import {mapGetters} from 'vuex';
import {EXPENSE_SUPPORTING_DOCS_UPLOAD_CATEGORY_CONFIG} from '@/helpers/baseConfig';
import FilesList from './FilesList.vue';

export default {
   name: 'SupportingDocumnets',
   components: {FilesList},
   props: {
      expenseType: {
         type: String,
         required: true,
         validator: (value) => ['cloud', 'supplies', 'contractors', 'employees'].includes(value),
      },
      disabled: {
         type: Boolean,
         required: false,
         default: false,
      },
   },
   computed: {
      ...mapGetters({
         uploadCategories: 'uploads/uploadCategories',
      }),
      uploadCategoryConfig() {
         return (
            EXPENSE_SUPPORTING_DOCS_UPLOAD_CATEGORY_CONFIG[this.expenseType] || {
               name: null,
               category: null,
            }
         );
      },
      categoryName() {
         return this.uploadCategoryConfig.name;
      },
      category() {
         return this.uploadCategoryConfig.category;
      },
      isUploadSupported() {
         return !!(this.categoryName && this.category);
      },
      uploadCategory() {
         return this.uploadCategories.find(({name}) => this.categoryName === name);
      },
   },
   methods: {
      async onFileUpload(event) {
         if (!this.isUploadSupported || !this.uploadCategory?.id) {
            this.$store.commit('showAlert', {
               msg: `Supporting document upload is not available for ${this.expenseType} yet.`,
               seconds: 5,
            });
            return;
         }

         await this.blockingRequest(`${this.expenseType}/uploadSupportingDocuments`, {
            files: [event.target.files[0]],
            uploadCategoryId: this.uploadCategory?.id,
         });
      },
   },
};
</script>

<template>
   <div>
      <div class="d-flex flex-row justify-content-between mb-2 mt-4" style="width: 100%">
         <h5 style="font-size: 16px" class="font-weight-bold">Supporting Documents</h5>
         <input type="file" ref="fileInput" @input="onFileUpload" style="display: none" />
         <b-button
            class="add-button"
            variant="primary"
            @click="$refs.fileInput.click()"
            :disabled="disabled || !isUploadSupported || !uploadCategory"
         >
            Add New +
         </b-button>
      </div>
      <FilesList
         v-if="categoryName"
         :category-name="categoryName"
         :category="category"
         empty-text="No supporting documents uploaded."
      />
   </div>
</template>

<style scoped lang="scss">
.add-button {
   padding: 5px 30px;
   font-size: 13px !important;
   background-color: #0072cc;
   border: 1px solid #1660a9;
   &:hover {
      background-color: #0072cc;
      border: 1px solid #1660a9;
   }
}
</style>
